import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export function useMutationEmailExists({ api }: { api: ApiType }) {
  return useMutation({
    mutationFn: async ({ email }: { email: string }) => {
      return (await api.public.userMemberApi.emailExists(email)).data;
    },
  });
}
